/**
 * Danh mục ngành nghề
 */
export default {
  ActivityManufact: 1,
  ActivityLottery: 2,
  ActivityProbe: 3,
  InvestmentProject: 4,
  FactoryElectrict: 5,
};
